import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect, useRef } from "react";

export function CountUp({ value, prefix = "", decimals = 0, className = "" }) {
  const mv = useMotionValue(0);
  const rounded = useTransform(mv, (v) =>
    prefix + Number(v).toFixed(decimals).toString()
  );
  const ref = useRef(null);
  useEffect(() => {
    const controls = animate(mv, Number(value) || 0, { duration: 1.1, ease: "easeOut" });
    return controls.stop;
  }, [value]);
  useEffect(() => {
    const unsub = rounded.on("change", (v) => {
      if (ref.current) ref.current.textContent = v;
    });
    return unsub;
  }, [rounded]);
  return <span ref={ref} className={className}>{prefix}0</span>;
}
